import { render, staticRenderFns } from "./UpdateEmail.vue?vue&type=template&id=0ca40530&scoped=true&"
import script from "./UpdateEmail.vue?vue&type=script&lang=ts&"
export * from "./UpdateEmail.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateEmail.vue?vue&type=style&index=0&id=0ca40530&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca40530",
  null
  
)

export default component.exports